import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const CustomTimeframeFilterStyled = styled.div`
  width: 100%;
`;

export const TimeTitle = styled.h3`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin-bottom: 0 0 20px 0;
`;

export const DividerContainer = styled.div<{ hasErrorMessage: boolean }>`
  margin: ${(props) => (props.hasErrorMessage ? '0' : '40px 0 0 0')};
`;
